/* tslint:disable */
/* eslint-disable */
/**
 * REST API for AWV-UI
 * AWV-UI向けのREST APIリファレンス  ## Version履歴 - 1.0:2023/4/28 初版作成 - 1.1:2023/6/30   - すべてのAPIリファレンスを一つにまとめた   - Suspend Task→Cancel Taskに名前を変更   - 認証開始　削除   - トークン更新　認証処理の見直しにより全体修正   - タスク取得　レスポンスのユーザ名をユーザIDに変更、タスク状態修正   - Awrs→Awvsに修正   - 完成機情報取得　レスポンスに「カメラ仕様」「名称ID」追加、パラメータに車台形式・番号追加   - Go Home Task　レスポンスのtaskIDをjobsetId修正   - 以下API新規追加     - WebRTC配信設定     - WebRTC接続情報取得     - WebRTCユーザー設定     - パスワードリセット     - アンロックアカウント実行     - アンロックアカウントメール送信 - 1.2:2023/7/28   - 地図情報取得　パラメータのinをpathに修正   - タスク作成状況確認　パラメータの指定方法修正   - UnlockAccountResponseStatus204のref先変更   - 全APIにoperationId付与   - Skip Task　エラーレスポンス追加   - Cancel Task　エラーレスポンス追加   - プロジェクト一覧取得　レスポンスにジョブサイト名追加　400エラー削除   - トークン更新　レスポンスの204を削除し200を追加。レスポンスにemail、roleNameを追加   - タスク取得　レスポンス、リクエストパラメータ修正   - 完成機情報取得　正常レスポンス(200)の応答をobject形式に修正。処理概要に完成機1台分の情報取得の旨追記   - タスク作成状況確認　正常レスポンス(200)の応答をobject形式に修正   - タスク更新　リクエストをリクエストボディに変更し内容を修正。レスポンス修正   - タスク取得　正常レスポンス(200)の応答をobject形式に修正   - タスク名一覧取得　正常レスポンス(200)の応答をobject形式に修正   - WebRTC配信設定情報　正常レスポンス(200)の応答をobject形式に修正   - タスク登録　リクエストパラメータの内容修正   - タスク削除　リクエストパラメータの内容修正   - タスク作成状況確認　タスク作成時の409エラーを追加   - API設計方針追記 及び伴うエラーコードレスポンスをstringに修正   - マップ503エラーレスポンスの説明を500から503に修正   - 地図更新確認　リクエストパラメータの内容修正。200レスポンスの内容修正。204レスポンス削除。   - タスク登録　リクエストパラメータにfrom地点ノードの停止時間追加   - タスク更新　リクエストパラメータにfrom地点ノードの停止時間追加   - タスク名一覧取得　経由ノードのリストと、from地点ノードでの停止時間をレスポンスに追加。   - タスク取得　パラメータの必須かどうかを修正。経路情報取得の要否削除。レスポンスの必須かどうかを修正。   - タスク名一覧取得　レスポンス名をキャメルケースに修正し、配列でなくした。   - タスク承認　リクエストパラメータをキャメルケースに修正   - タスク取得　リクエストパラメータに「再計算タスク取得フラグ」を追加。レスポンスの必須かどうかを修正。   - WebRTC接続情報取得　レスポンスパラメータから「日時」を削除。「webRTC配信の停止」のパラメータ名を修正   - タスク作成状況確認　 レスポンスパラメータ名を修正 jobsetStatus → jobSetStatus   - Go Home Task、Cancel Task、Skip Taskを一つのタグにまとめた。   - パラメータ等にrequireで存在しないものが指定されているのを修正   - ResistTaskDataをRegisterTaskDataに修正   - 交通状況編集　レスポンス内容をバージョンIDのみに修正。204削除。   - Go Home Task実行 リクエストパラメータの日時情報候補リスト削除し、fromノードIDと開始希望日時追加。 - 1.3:2023/9/29   - Go Home Task実行　パラメータのrequireを修正   - WebRTC配信設定　「WebRTC解像度」と「WebRTCフレームレート」をrequireから外した   - 地図情報取得　レスポンスの地図情報の内容修正。204レスポンス削除。レスポンスに作成日時、更新日時、作成ユーザを追加。   - 交通状況編集　パラメータの地図情報をエッジ更新情報に修正   - 完成機情報取得　パラメータのgeoSiteId→jobSiteIdに修正。204レスポンス削除。   - usersに属するAPIから、AUTHORIZATIONS:PermissionTokenを削除   - タスク取得　Dateをdateにし、型も修正。レスポンスの「タスク実行予定時刻」の名称を「タスク実行予定時間（分）」に修正。レスポンスの経路情報にノードの到着時間と出発時間を追加。JobInfosの内部的な仕様修正。画面表示用タスクIDの例のスペル修正。レスポンスのバージョンIDに説明追加。   - 通知一覧取得　APIの説明文修正。パラメータの取得上限数の説明文修正、requireに指定、範囲を1～500に指定。レスポンスの通知情報内容修正。レスポンスに「車台形式・番号」追加404エラー追加。レスポンスに画面表示用タスクID追加。   - 通知既読　削除。   - 通知更新確認　APIの説明文修正。レスポンスの最新通知情報において、該当するイベントが0件だった場合未設定(null)とする旨を説明に追記及びレスポンスに「車台形式・番号」追加。レスポンスに画面表示用タスクID追加。   - プロジェクト一覧取得　ソートして返却する旨を記載   - トークン更新　レスポンスに名前、名字を追加   - jobsetStatus → jobSetStatusに修正   - メモ設定のpatternに空白文字追加 及び 1個以上ではなく0個以上に一致するよう修正   - タスク登録　パラメータのextensionTimeLoadをrequiredから外し、説明文を修正   - タスク更新　パラメータのextensionTimeLoadをrequiredから外した。   - タスク承認　リクエストボディをリスト化。   - タスク名一覧取得　JobInfosの内部的な仕様修正。extensionTimeLoadをrequiredから外した。   - WebRTCユーザー設定　200レスポンスを204に修正。   - WebRTC接続情報取得 200レスポンスの説明文修正。 - 1.4:2023/10/24   - 交通状況編集のレスポンスに最適化対象ジョブセットIDリストを追加   - タスク取得のパラメータに最適化対象ジョブセットIDリストを追加 - 1.4.1:2023/10/31   - タスク取得(一括承認用)APIを追加し、タスク取得APIから該当パラメータを削除 - 1.4.2:2023/11/08   - タスク取得(一括承認用)APIのリクエストパラメータを最適化対象ジョブセットIDからオブジェクトに修正   - 交通状況編集のレスポンスの最適化対象ジョブセットIDからオブジェクトに修正   - タスク取得APIのリクエストパラメータの地図バージョンを削除 - 1.4.3:2024/01/10   - タスク取得APIのレスポンスに移動タスク生成フラグを追加   - タスク登録APIのリクエストパラメータにタスク補完設定(移動タスク生成フラグ)を追加   - タスク取得APIのリクエストパラメータに承認待ちタスクのみ取得するフラグを追加   - 完成機情報取得のレスポンスの内容修正(conditionに「OTA中」を追加)   - 完成機情報取得のレスポンスに自律走行可否を追加 - 1.4.4:2024/01/23   - タスク取得のリクエストパラメータにパスデータを取得するか否かのフラグを追加   - タスク取得のレスポンスに経由パスのリストを追加   - プロジェクト一覧取得APIのレスポンスに地理サイト名と{ジョブサイトID, ジョブサイト名}を追加   - 地図情報取得APIのリクエストパラメータをジョブサイトIDから地図IDに変更   - 地図一覧取得APIを追加 - 1.4.5:2024/02/15   - 地図情報取得のレスポンスタイプMapEdgeTypeにoneWayを追加 - 1.5:2024/03/06   - 緊急停止実行APIを追加 - 1.6:2024/10/04   - 荷物情報取得APIを追加   - 充電器情報取得APIを追加 - 1.7:2024/10/17   - 充電運行計画のタスク登録APIを追加   - 充電運行計画のタスク更新APIを追加   - 充電運行計画のタスク取得APIを追加   - 充電運行計画のタスク名一覧取得APIを追加 - 1.8:2024/10/22   - ユーザー一覧取得APIを追加   - プロジェクト一覧取得のレスポンスに組織ID追加   - 充電運行計画のタスク名一覧取得のリクエストパラメータにinputDateを追加 - 1.8.1:2024/10/25   - 充電運行計画のタスク登録のリクエストパラメータにendDatetimeを追加   - 充電運行計画のタスク更新のリクエストパラメータにendDatetimeを追加 - 1.8.2:2024/11/07   - 充電運行計画のタスク名一覧取得のリクエストパラメータにjobSetIdを追加 - 1.8.3:2024/11/11   - 充電運行計画のタスク名一覧取得のレスポンスのjobInfosにjobIdを追加 - 1.8.4:2024/11/18   - 充電運行計画のタスク取得のレスポンスにバージョンIDを追加   - 充電運行計画のタスク名一覧取得のレスポンスにバージョンIDを追加 - 1.8.5:2024/11/21   - 充電運行計画のタスク登録／更新リクエストのジョブ終了希望日時のパラメータ名を修正 - 1.8.6:2024/11/22   - 充電運行計画のタスク取得のレスポンスに荷物数量を追加 - 1.8.7:2024/11/28   - 充電運行計画のタスク取得のレスポンスのjobPlanningEndDatetimeをrequiredから外した。  ## API設計方針 - 要求仕様: [API設計ガイドライン](https://hndx-gh-ex01.rd.honda.co.jp/OPPF-2X-DEV-COMMON-COMPONENTS/requirements/blob/master/api/api_design_guideline.md) - Description は APIの概要の記載にとどめ、初期値といった Swagger で用意されている記載方法がある場合はそれに則る書き方にする。 - OP-PFからのエラーレスポンスコードがある場合はintgerからstringに変換して返す。  上記を設計原則とするが、例外となるものは明記する。  ## Deprecated APIについて OP-PF AWV-UIにおいて、初期に利用されていたAPIをDeprecatedとして明示している。 - 新規での利用はしないこと。 - 実装のメンテナンスは行われず、テスト対象にもしない。 - 将来的に実装は取り除かれ、API仕様からも削除される 
 *
 * The version of the OpenAPI document: 1.8.6
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  BodyJobsetApproval,
  BodyOptimizeJobSets,
  ClientErrorResponse,
  CreateTask201Response,
  PlanJobsetStatus,
  RegisterTaskData,
  RegisterTaskDataMultipleCharge,
  ResultTaskLists,
  ResultTaskListsMultipleCharge,
  SelectTaskLists,
  SelectTaskListsMultipleCharge,
  ServerErrorResponse,
  ServiceErrorResponse,
  TaskCreateErrorResponse,
  TaskErrorResponse,
  UpdateTaskData,
  UpdateTaskDataMultipleCharge,
} from '../models';
import {
    BodyJobsetApprovalFromJSON,
    BodyJobsetApprovalToJSON,
    BodyOptimizeJobSetsFromJSON,
    BodyOptimizeJobSetsToJSON,
    ClientErrorResponseFromJSON,
    ClientErrorResponseToJSON,
    CreateTask201ResponseFromJSON,
    CreateTask201ResponseToJSON,
    PlanJobsetStatusFromJSON,
    PlanJobsetStatusToJSON,
    RegisterTaskDataFromJSON,
    RegisterTaskDataToJSON,
    RegisterTaskDataMultipleChargeFromJSON,
    RegisterTaskDataMultipleChargeToJSON,
    ResultTaskListsFromJSON,
    ResultTaskListsToJSON,
    ResultTaskListsMultipleChargeFromJSON,
    ResultTaskListsMultipleChargeToJSON,
    SelectTaskListsFromJSON,
    SelectTaskListsToJSON,
    SelectTaskListsMultipleChargeFromJSON,
    SelectTaskListsMultipleChargeToJSON,
    ServerErrorResponseFromJSON,
    ServerErrorResponseToJSON,
    ServiceErrorResponseFromJSON,
    ServiceErrorResponseToJSON,
    TaskCreateErrorResponseFromJSON,
    TaskCreateErrorResponseToJSON,
    TaskErrorResponseFromJSON,
    TaskErrorResponseToJSON,
    UpdateTaskDataFromJSON,
    UpdateTaskDataToJSON,
    UpdateTaskDataMultipleChargeFromJSON,
    UpdateTaskDataMultipleChargeToJSON,
} from '../models';

export interface ApproveTaskRequest {
    bodyJobsetApproval: Array<BodyJobsetApproval>;
}

export interface CreateTaskRequest {
    registerTaskData: RegisterTaskData;
}

export interface CreateTaskMultipleChargeRequest {
    registerTaskDataMultipleCharge: RegisterTaskDataMultipleCharge;
}

export interface DeleteTaskRequest {
    taskKind: number;
    jobSetId?: string;
    taskId?: number;
    frameTypeAndNumber?: string;
}

export interface GetBatchTaskRequest {
    bodyOptimizeJobSets: BodyOptimizeJobSets;
}

export interface GetTaskRequest {
    frameTypeAndNumberList: Array<string>;
    mapId: string;
    jobSetId?: string;
    date?: Date;
    timezone?: string;
    isApproval?: boolean | null;
    needsPath?: boolean;
}

export interface GetTaskCreateProgressRequest {
    jobSetId: string;
}

export interface GetTaskListRequest {
    frameTypeAndNumber: string;
    mapId: string;
}

export interface GetTaskListMultipleChargeRequest {
    mapId: string;
    jobSetId?: string;
}

export interface GetTaskMultipleChargeRequest {
    jobSetId: string;
}

export interface UpdateTaskRequest {
    updateTaskData: UpdateTaskData;
}

export interface UpdateTaskMultipleChargeRequest {
    updateTaskDataMultipleCharge: UpdateTaskDataMultipleCharge;
}

/**
 * 
 */
export class TasksApi extends runtime.BaseAPI {

    /**
     * OP-PFに作成されたタスクを承認又は否認する。
     * タスク承認
     */
    async approveTaskRaw(requestParameters: ApproveTaskRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.bodyJobsetApproval === null || requestParameters.bodyJobsetApproval === undefined) {
            throw new runtime.RequiredError('bodyJobsetApproval','Required parameter requestParameters.bodyJobsetApproval was null or undefined when calling approveTask.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-lc-permission-token"] = await this.configuration.apiKey("x-lc-permission-token"); // PermissionToken authentication
        }

        const response = await this.request({
            path: `/AUTO_VEHICLE/tasks/approval`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.bodyJobsetApproval.map(BodyJobsetApprovalToJSON),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * OP-PFに作成されたタスクを承認又は否認する。
     * タスク承認
     */
    async approveTask(requestParameters: ApproveTaskRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.approveTaskRaw(requestParameters, initOverrides);
    }

    /**
     * タスク登録を行う。
     * タスク登録
     */
    async createTaskRaw(requestParameters: CreateTaskRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateTask201Response>> {
        if (requestParameters.registerTaskData === null || requestParameters.registerTaskData === undefined) {
            throw new runtime.RequiredError('registerTaskData','Required parameter requestParameters.registerTaskData was null or undefined when calling createTask.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-lc-permission-token"] = await this.configuration.apiKey("x-lc-permission-token"); // PermissionToken authentication
        }

        const response = await this.request({
            path: `/AUTO_VEHICLE/tasks`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RegisterTaskDataToJSON(requestParameters.registerTaskData),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateTask201ResponseFromJSON(jsonValue));
    }

    /**
     * タスク登録を行う。
     * タスク登録
     */
    async createTask(requestParameters: CreateTaskRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateTask201Response> {
        const response = await this.createTaskRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 充電運行計画のタスク登録を行う。
     * 充電運行計画のタスク登録
     */
    async createTaskMultipleChargeRaw(requestParameters: CreateTaskMultipleChargeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateTask201Response>> {
        if (requestParameters.registerTaskDataMultipleCharge === null || requestParameters.registerTaskDataMultipleCharge === undefined) {
            throw new runtime.RequiredError('registerTaskDataMultipleCharge','Required parameter requestParameters.registerTaskDataMultipleCharge was null or undefined when calling createTaskMultipleCharge.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-lc-permission-token"] = await this.configuration.apiKey("x-lc-permission-token"); // PermissionToken authentication
        }

        const response = await this.request({
            path: `/AUTO_VEHICLE/tasks/multiple-charge`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RegisterTaskDataMultipleChargeToJSON(requestParameters.registerTaskDataMultipleCharge),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateTask201ResponseFromJSON(jsonValue));
    }

    /**
     * 充電運行計画のタスク登録を行う。
     * 充電運行計画のタスク登録
     */
    async createTaskMultipleCharge(requestParameters: CreateTaskMultipleChargeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateTask201Response> {
        const response = await this.createTaskMultipleChargeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * OP-PFに作成されたタスク(ジョブセット)を削除する。
     * タスク削除
     */
    async deleteTaskRaw(requestParameters: DeleteTaskRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.taskKind === null || requestParameters.taskKind === undefined) {
            throw new runtime.RequiredError('taskKind','Required parameter requestParameters.taskKind was null or undefined when calling deleteTask.');
        }

        const queryParameters: any = {};

        if (requestParameters.jobSetId !== undefined) {
            queryParameters['jobSetId'] = requestParameters.jobSetId;
        }

        if (requestParameters.taskId !== undefined) {
            queryParameters['taskId'] = requestParameters.taskId;
        }

        if (requestParameters.frameTypeAndNumber !== undefined) {
            queryParameters['frameTypeAndNumber'] = requestParameters.frameTypeAndNumber;
        }

        if (requestParameters.taskKind !== undefined) {
            queryParameters['taskKind'] = requestParameters.taskKind;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-lc-permission-token"] = await this.configuration.apiKey("x-lc-permission-token"); // PermissionToken authentication
        }

        const response = await this.request({
            path: `/AUTO_VEHICLE/tasks`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * OP-PFに作成されたタスク(ジョブセット)を削除する。
     * タスク削除
     */
    async deleteTask(requestParameters: DeleteTaskRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteTaskRaw(requestParameters, initOverrides);
    }

    /**
     * OP-PFに登録されているタスクを取得する。指定のジョブセットIDが再計算完了後に承認待ちとなっているタスクを取得する。 
     * タスク取得(一括承認)
     */
    async getBatchTaskRaw(requestParameters: GetBatchTaskRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultTaskLists>> {
        if (requestParameters.bodyOptimizeJobSets === null || requestParameters.bodyOptimizeJobSets === undefined) {
            throw new runtime.RequiredError('bodyOptimizeJobSets','Required parameter requestParameters.bodyOptimizeJobSets was null or undefined when calling getBatchTask.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-lc-permission-token"] = await this.configuration.apiKey("x-lc-permission-token"); // PermissionToken authentication
        }

        const response = await this.request({
            path: `/AUTO_VEHICLE/tasks/batch`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BodyOptimizeJobSetsToJSON(requestParameters.bodyOptimizeJobSets),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultTaskListsFromJSON(jsonValue));
    }

    /**
     * OP-PFに登録されているタスクを取得する。指定のジョブセットIDが再計算完了後に承認待ちとなっているタスクを取得する。 
     * タスク取得(一括承認)
     */
    async getBatchTask(requestParameters: GetBatchTaskRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultTaskLists> {
        const response = await this.getBatchTaskRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * OP-PFに登録されているタスクを取得する。利用用途に応じて以下のパラメータを組み合わせる。 1. タスクリスト表示時(1日分の全タスクを取得)     - frameTypeAndNumberList     - mapId     - date     - timezone 2. タスク登録、更新時のタスク承認前(1つのタスクを取得)     - frameTypeAndNumberList     - jobSetId     - mapId 3. タスク中断失敗時にタスク状態を確認するとき(jobSetIdに対応するタスクを取得)     - frameTypeAndNumberList     - jobSetId     - mapId     - isApproval: false 4. タスク中断失敗時にタスク状態を確認するとき(jobSetIdに対応するタスクを取得)     - frameTypeAndNumberList     - jobSetId     - mapId     - isApproval: false 5. 位置合わせモード表示時(jobSetIdに対応するタスクと経路パス情報とを取得)     - frameTypeAndNumberList     - jobSetId     - mapId     - isApproval: false     - needsPath: true 
     * タスク取得
     */
    async getTaskRaw(requestParameters: GetTaskRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultTaskLists>> {
        if (requestParameters.frameTypeAndNumberList === null || requestParameters.frameTypeAndNumberList === undefined) {
            throw new runtime.RequiredError('frameTypeAndNumberList','Required parameter requestParameters.frameTypeAndNumberList was null or undefined when calling getTask.');
        }

        if (requestParameters.mapId === null || requestParameters.mapId === undefined) {
            throw new runtime.RequiredError('mapId','Required parameter requestParameters.mapId was null or undefined when calling getTask.');
        }

        const queryParameters: any = {};

        if (requestParameters.frameTypeAndNumberList) {
            queryParameters['frameTypeAndNumberList'] = requestParameters.frameTypeAndNumberList;
        }

        if (requestParameters.jobSetId !== undefined) {
            queryParameters['jobSetId'] = requestParameters.jobSetId;
        }

        if (requestParameters.mapId !== undefined) {
            queryParameters['mapId'] = requestParameters.mapId;
        }

        if (requestParameters.date !== undefined) {
            queryParameters['date'] = (requestParameters.date as any).toISOString().substr(0,10);
        }

        if (requestParameters.timezone !== undefined) {
            queryParameters['timezone'] = requestParameters.timezone;
        }

        if (requestParameters.isApproval !== undefined) {
            queryParameters['isApproval'] = requestParameters.isApproval;
        }

        if (requestParameters.needsPath !== undefined) {
            queryParameters['needsPath'] = requestParameters.needsPath;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-lc-permission-token"] = await this.configuration.apiKey("x-lc-permission-token"); // PermissionToken authentication
        }

        const response = await this.request({
            path: `/AUTO_VEHICLE/tasks`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultTaskListsFromJSON(jsonValue));
    }

    /**
     * OP-PFに登録されているタスクを取得する。利用用途に応じて以下のパラメータを組み合わせる。 1. タスクリスト表示時(1日分の全タスクを取得)     - frameTypeAndNumberList     - mapId     - date     - timezone 2. タスク登録、更新時のタスク承認前(1つのタスクを取得)     - frameTypeAndNumberList     - jobSetId     - mapId 3. タスク中断失敗時にタスク状態を確認するとき(jobSetIdに対応するタスクを取得)     - frameTypeAndNumberList     - jobSetId     - mapId     - isApproval: false 4. タスク中断失敗時にタスク状態を確認するとき(jobSetIdに対応するタスクを取得)     - frameTypeAndNumberList     - jobSetId     - mapId     - isApproval: false 5. 位置合わせモード表示時(jobSetIdに対応するタスクと経路パス情報とを取得)     - frameTypeAndNumberList     - jobSetId     - mapId     - isApproval: false     - needsPath: true 
     * タスク取得
     */
    async getTask(requestParameters: GetTaskRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultTaskLists> {
        const response = await this.getTaskRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * タスク登録が完了しているかを確認する。
     * タスク作成状況確認
     */
    async getTaskCreateProgressRaw(requestParameters: GetTaskCreateProgressRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PlanJobsetStatus>> {
        if (requestParameters.jobSetId === null || requestParameters.jobSetId === undefined) {
            throw new runtime.RequiredError('jobSetId','Required parameter requestParameters.jobSetId was null or undefined when calling getTaskCreateProgress.');
        }

        const queryParameters: any = {};

        if (requestParameters.jobSetId !== undefined) {
            queryParameters['jobSetId'] = requestParameters.jobSetId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-lc-permission-token"] = await this.configuration.apiKey("x-lc-permission-token"); // PermissionToken authentication
        }

        const response = await this.request({
            path: `/AUTO_VEHICLE/tasks/state`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PlanJobsetStatusFromJSON(jsonValue));
    }

    /**
     * タスク登録が完了しているかを確認する。
     * タスク作成状況確認
     */
    async getTaskCreateProgress(requestParameters: GetTaskCreateProgressRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PlanJobsetStatus> {
        const response = await this.getTaskCreateProgressRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * OP-PFに登録されているタスク名一覧を取得する。
     * タスク名一覧取得
     */
    async getTaskListRaw(requestParameters: GetTaskListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SelectTaskLists>> {
        if (requestParameters.frameTypeAndNumber === null || requestParameters.frameTypeAndNumber === undefined) {
            throw new runtime.RequiredError('frameTypeAndNumber','Required parameter requestParameters.frameTypeAndNumber was null or undefined when calling getTaskList.');
        }

        if (requestParameters.mapId === null || requestParameters.mapId === undefined) {
            throw new runtime.RequiredError('mapId','Required parameter requestParameters.mapId was null or undefined when calling getTaskList.');
        }

        const queryParameters: any = {};

        if (requestParameters.frameTypeAndNumber !== undefined) {
            queryParameters['frameTypeAndNumber'] = requestParameters.frameTypeAndNumber;
        }

        if (requestParameters.mapId !== undefined) {
            queryParameters['mapId'] = requestParameters.mapId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-lc-permission-token"] = await this.configuration.apiKey("x-lc-permission-token"); // PermissionToken authentication
        }

        const response = await this.request({
            path: `/AUTO_VEHICLE/tasks/names`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SelectTaskListsFromJSON(jsonValue));
    }

    /**
     * OP-PFに登録されているタスク名一覧を取得する。
     * タスク名一覧取得
     */
    async getTaskList(requestParameters: GetTaskListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SelectTaskLists> {
        const response = await this.getTaskListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * OP-PFに登録されている充電運行計画のタスク名一覧を取得する。
     * 充電運行計画のタスク名一覧取得
     */
    async getTaskListMultipleChargeRaw(requestParameters: GetTaskListMultipleChargeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SelectTaskListsMultipleCharge>> {
        if (requestParameters.mapId === null || requestParameters.mapId === undefined) {
            throw new runtime.RequiredError('mapId','Required parameter requestParameters.mapId was null or undefined when calling getTaskListMultipleCharge.');
        }

        const queryParameters: any = {};

        if (requestParameters.mapId !== undefined) {
            queryParameters['mapId'] = requestParameters.mapId;
        }

        if (requestParameters.jobSetId !== undefined) {
            queryParameters['jobSetId'] = requestParameters.jobSetId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-lc-permission-token"] = await this.configuration.apiKey("x-lc-permission-token"); // PermissionToken authentication
        }

        const response = await this.request({
            path: `/AUTO_VEHICLE/tasks/multiple-charge/names`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SelectTaskListsMultipleChargeFromJSON(jsonValue));
    }

    /**
     * OP-PFに登録されている充電運行計画のタスク名一覧を取得する。
     * 充電運行計画のタスク名一覧取得
     */
    async getTaskListMultipleCharge(requestParameters: GetTaskListMultipleChargeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SelectTaskListsMultipleCharge> {
        const response = await this.getTaskListMultipleChargeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * OP-PFに登録されている充電運行計画のタスクを取得する。 
     * 充電運行計画のタスク取得
     */
    async getTaskMultipleChargeRaw(requestParameters: GetTaskMultipleChargeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultTaskListsMultipleCharge>> {
        if (requestParameters.jobSetId === null || requestParameters.jobSetId === undefined) {
            throw new runtime.RequiredError('jobSetId','Required parameter requestParameters.jobSetId was null or undefined when calling getTaskMultipleCharge.');
        }

        const queryParameters: any = {};

        if (requestParameters.jobSetId !== undefined) {
            queryParameters['jobSetId'] = requestParameters.jobSetId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-lc-permission-token"] = await this.configuration.apiKey("x-lc-permission-token"); // PermissionToken authentication
        }

        const response = await this.request({
            path: `/AUTO_VEHICLE/tasks/multiple-charge`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultTaskListsMultipleChargeFromJSON(jsonValue));
    }

    /**
     * OP-PFに登録されている充電運行計画のタスクを取得する。 
     * 充電運行計画のタスク取得
     */
    async getTaskMultipleCharge(requestParameters: GetTaskMultipleChargeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultTaskListsMultipleCharge> {
        const response = await this.getTaskMultipleChargeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * タスク更新を行う。
     * タスク更新
     */
    async updateTaskRaw(requestParameters: UpdateTaskRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.updateTaskData === null || requestParameters.updateTaskData === undefined) {
            throw new runtime.RequiredError('updateTaskData','Required parameter requestParameters.updateTaskData was null or undefined when calling updateTask.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-lc-permission-token"] = await this.configuration.apiKey("x-lc-permission-token"); // PermissionToken authentication
        }

        const response = await this.request({
            path: `/AUTO_VEHICLE/tasks`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateTaskDataToJSON(requestParameters.updateTaskData),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * タスク更新を行う。
     * タスク更新
     */
    async updateTask(requestParameters: UpdateTaskRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateTaskRaw(requestParameters, initOverrides);
    }

    /**
     * 充電運行計画のタスク更新を行う。
     * 充電運行計画のタスク更新
     */
    async updateTaskMultipleChargeRaw(requestParameters: UpdateTaskMultipleChargeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.updateTaskDataMultipleCharge === null || requestParameters.updateTaskDataMultipleCharge === undefined) {
            throw new runtime.RequiredError('updateTaskDataMultipleCharge','Required parameter requestParameters.updateTaskDataMultipleCharge was null or undefined when calling updateTaskMultipleCharge.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-lc-permission-token"] = await this.configuration.apiKey("x-lc-permission-token"); // PermissionToken authentication
        }

        const response = await this.request({
            path: `/AUTO_VEHICLE/tasks/multiple-charge`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateTaskDataMultipleChargeToJSON(requestParameters.updateTaskDataMultipleCharge),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * 充電運行計画のタスク更新を行う。
     * 充電運行計画のタスク更新
     */
    async updateTaskMultipleCharge(requestParameters: UpdateTaskMultipleChargeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateTaskMultipleChargeRaw(requestParameters, initOverrides);
    }

}
